import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Quote, Briefcase } from "lucide-react";
import { FOUNDER } from "../data/mock";
import Reveal from "../components/Reveal";
import { PageHero, CTABand } from "../components/SharedUI";

const Founder = () => {
  const d = FOUNDER;
  return (
    <div>
      <PageHero eyebrow={d.eyebrow} lines={d.titleLines} intro={d.intro} />

      {/* Profile */}
      <section className="bg-[var(--cream)] py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8 grid lg:grid-cols-[0.85fr_1.15fr] gap-14 lg:gap-20 items-start">
          {/* portrait card */}
          <Reveal>
            <div className="lg:sticky lg:top-32">
              <div className="relative">
                <div className="absolute -inset-4 border border-[var(--gold)]/40 rounded-sm translate-x-4 -translate-y-4" />
                <div className="relative bg-[#16233f] grain rounded-sm overflow-hidden shadow-2xl aspect-[4/5] flex items-center justify-center">
                  <div className="text-center px-8">
                    <div className="w-32 h-32 mx-auto rounded-full bg-white flex items-center justify-center p-3 shadow-lg mb-8">
                      <img src="/assets/logo-mark.png" alt="PT Hiring Solutions" className="w-full h-full object-contain" />
                    </div>
                    <div className="font-serif text-4xl md:text-5xl text-white font-semibold leading-none">
                      {d.name}
                    </div>
                    <div className="eyebrow mt-4">{d.role}</div>
                    <div className="mt-10 h-px w-16 bg-[var(--gold)]/50 mx-auto" />
                    <p className="text-white/60 text-sm mt-6 leading-relaxed">{d.credential}</p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* bio + industries */}
          <div>
            <Reveal>
              <h2 className="font-serif text-[34px] md:text-[46px] font-semibold text-[#14161c] leading-[1.08] mb-8">
                Cross-industry talent strategy,
                <span className="italic text-[var(--gold)]"> honed over 15+ years.</span>
              </h2>
            </Reveal>
            <Reveal delay={100}>
              <p className="text-[#55585f] text-lg leading-relaxed mb-12">{d.bio}</p>
            </Reveal>

            <Reveal delay={160}>
              <div className="eyebrow mb-6">Sectors of expertise</div>
            </Reveal>
            <div className="grid sm:grid-cols-2 gap-4">
              {d.industries.map((ind, i) => (
                <Reveal key={ind} delay={i * 80}>
                  <div className="flex items-center gap-4 bg-white border border-black/5 rounded-sm px-5 py-4 hover:border-[var(--gold)]/40 hover:-translate-y-0.5 transition-all duration-300">
                    <span className="w-10 h-10 rounded-sm bg-[#16233f] flex items-center justify-center shrink-0">
                      <Briefcase size={18} className="text-[var(--gold)]" />
                    </span>
                    <span className="font-serif text-lg text-[#14161c]">{ind}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Message from the founder */}
      <section className="grain bg-[#16233f] text-white py-24 md:py-32">
        <div className="max-w-[900px] mx-auto px-6 md:px-8">
          <Reveal>
            <Quote size={56} className="text-[var(--gold)]/40 mb-8" />
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-[30px] md:text-[42px] font-semibold italic mb-10">
              {d.messageHeading}
            </h2>
          </Reveal>
          <div className="space-y-7">
            {d.message.map((p, i) => (
              <Reveal key={i} delay={100 + i * 60}>
                <p className="text-white/75 text-lg md:text-xl leading-relaxed font-light">{p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={200}>
            <div className="mt-14 pt-10 border-t border-white/10">
              <div className="font-serif text-3xl text-[var(--gold)] italic mb-2">{d.signature}</div>
              <div className="eyebrow">{d.signatureRole}</div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Highlights */}
      <section className="bg-[var(--cream)] py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8 grid sm:grid-cols-3 gap-10">
          {d.highlights.map((h, i) => (
            <Reveal key={h.label} delay={i * 90}>
              <div className="text-center sm:text-left">
                <div className="font-serif text-[52px] md:text-[64px] text-[var(--gold)] font-semibold leading-none">
                  {h.value}
                </div>
                <div className="text-[#55585f] mt-3">{h.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand title={d.cta.title} button={d.cta.button} />
    </div>
  );
};

export default Founder;
